import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { Http } from '@angular/http';
import { FormBuilder, Validators, MinLengthValidator } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';  
import { BuyserviceService } from './buyservice.service';
import { SessionStorageService } from 'ngx-webstorage';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-buy-tokens',
  templateUrl: './buy-tokens.component.html',
  styleUrls: ['./buy-tokens.component.css']
})
export class BuyTokensComponent implements OnInit {
  buytokensForm: any;
  pricecal: any;
  currentprice: any;
  coinPrice: any;
  constructor(private  commonService: CommonService, private spinner: NgxSpinnerService, private session: SessionStorageService, private http: Http, private formBuilder: FormBuilder, private routes: Router, private alertService: AlertService, private buyService: BuyserviceService) { 
    this.buytokensForm = this.formBuilder.group({
      'tokenamount': ['', Validators.compose([
        Validators.required,Validators.min(100)
      ])],
      'fundingsum': ['', Validators.compose([
        Validators.required,Validators.min(50)
      ])]
    });
  }

  ngOnInit() {
    if(this.session.retrieve('token')){
      this.commonService.tokenValidity().then((res: any) => {
        this.spinner.hide();
        }).catch((err: any) => {     
            this.alertService.danger(err.message);
            this.spinner.hide();
            this.routes.navigate(['/login']);
      });
    }else{      
      this.routes.navigate(['/login']);
    }
    this.spinner.show();
    this.buyService.getDetails().then((res: any)  => {
       this.spinner.hide();
    if(res.status){
      this.currentprice = res.tokenrate;
    }
  });
  }

  submit() {
    if(!this.buytokensForm.valid){
      Object.keys(this.buytokensForm.controls).forEach(field => { 
        const control = this.buytokensForm.get(field);           
        control.markAsDirty({ onlySelf: true }); 
      });
      return;
    }
    this.spinner.show();
      this.buyService.check(this.buytokensForm.value.tokenamount,(this.buytokensForm.value.tokenamount * this.currentprice), this.currentprice).then((res: any) => {
        this.spinner.hide();
        if(res.status=='success'){
          this.routes.navigate(['main/purchaseorder',], { queryParams: { 'address': res.WalletAddress, 'value': res.btcusd } });
        }else{
          this.spinner.hide();
          this.alertService.danger('Unautherized User');
        }
      }).catch((err: any) => {this.alertService.danger(err.message)
      });
  }
spendSum(event) {  
  this.buyService.getDetails().then((res: any)  => {
    var val = (event.target.value)*res.tokenrate;
    var nakl = val.toFixed(2);
    this.buytokensForm.controls.fundingsum.patchValue(nakl);
  });
}

spendSumUSD(event) {  
  this.buyService.getDetails().then((res: any)  => {
    var val = (event.target.value)*(1/res.tokenrate);
    var nakl = val.toFixed(2);
    this.buytokensForm.controls.tokenamount.patchValue(nakl);
  });
}
}
